import { Bookmark, Compass, House, User } from 'lucide-react';
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router';
import { AppShell, type NavItem } from '../components/layout/AppShell';
import { RequireAuth } from '../features/auth/RequireAuth';
import { RootLayout } from './RootLayout';

const LoginPage = lazy(() => import('../features/auth/LoginPage'));
const LibraryPage = lazy(() => import('../features/library/LibraryPage'));
const BookmarksPage = lazy(() => import('../features/library/BookmarksPage'));
const DiscoverPage = lazy(() => import('../features/discover/DiscoverPage'));
const DocumentPage = lazy(() => import('../features/documents/DocumentPage'));
const OpenLibraryBookPage = lazy(() => import('../features/books/OpenLibraryBookPage'));
const ReaderPage = lazy(() => import('../features/reader/ReaderPage'));
const MangaPage = lazy(() => import('../features/manga/MangaPage'));
const ScanReaderPage = lazy(() => import('../features/books/ScanReaderPage'));
const AccountPage = lazy(() => import('../features/account/AccountPage'));
const NotFoundPage = lazy(() => import('./NotFoundPage'));

const nav: NavItem[] = [
  { to: '/', label: 'Home', icon: House },
  { to: '/discover', label: 'Discover', icon: Compass },
  { to: '/bookmarks', label: 'Bookmarks', icon: Bookmark },
  { to: '/account', label: 'Account', icon: User, phoneOnly: true },
];

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      {
        element: <RequireAuth />,
        children: [
          // The readers take the whole screen; everything else sits in the shell.
          { path: 'read/:documentId', element: <ReaderPage /> },
          { path: 'books/:workId/read', element: <ScanReaderPage /> },
          {
            element: <AppShell nav={nav} />,
            children: [
              { index: true, element: <LibraryPage /> },
              { path: 'discover', element: <DiscoverPage /> },
              { path: 'bookmarks', element: <BookmarksPage /> },
              { path: 'documents/:documentId', element: <DocumentPage /> },
              { path: 'books/:workId', element: <OpenLibraryBookPage /> },
              { path: 'manga/:mangaId', element: <MangaPage /> },
              { path: 'account', element: <AccountPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
